let controller = new AbortController()

export function getSessionSignal(): AbortSignal {
	return controller.signal
}

export function abortSessionRequests(): void {
	controller.abort()
	controller = new AbortController()
}
